import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Row, Col, Card, Tabs } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'
import userProfileImageHolder from '../user_profile.jpg';
import userProfile from '../user_profile.jpg';
import Image from 'react-image-resizer';
import moment from 'moment';
import NumberFormat from 'react-number-format';

const API_HOST_URL = process.env.REACT_APP_API_URL

const style = {
    profileImage: {
        display: 'inline',
        margin: '0 auto',
        // marginLeft: '-25%',
        height: '100%',
        width: 'auto'
    },
    
};

class UserProfile extends Component {

    state = {
        user: {},
        upcomingTrips: []
    }

    componentDidMount() {
        this.upcomingTrips();
        this.getUser();
    }

    getUser(){
        // const userId = this.props.loggedInUser.pk
        const userId = this.props.match.params.userId;
        console.log("get user: ", userId)
        axios.get(`${API_HOST_URL}/api/userprofile/users/${userId}/`)
            .then(res => {
                this.setState({
                    user: res.data
                })

                console.log("User Info: ", res.data);
            })
            .catch(err => {
                console.log("Error: ", JSON.stringify(err));
            })
    }

    upcomingTrips = () => {
        const userId = this.props.match.params.userId;
        axios.get(`${API_HOST_URL}/api/trips/upcoming_trips_posted_by_user/?user_id=${userId}`)
            .then(res => {
                this.setState({
                    upcomingTrips: res.data
                },
                    () => {
                        console.log("upcoming trips fetched: ", this.state.upcomingTrips)
                    })
            })
    }
    callback(key) {
        console.log(key);
    }

    showDescriptionModal = () => { }

    isEmpty(obj) {
        for(var key in obj) {
            if(obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }


    render() {
        const TabPane = Tabs.TabPane;
        const { loggedInUser } = this.props;
        const { user, upcomingTrips } = this.state
        console.log("props with loggedInUser", loggedInUser)

        return (
            <div>
                {/* <MainHeader/> */}
                <br />
                <Row type="flex">
                    <Col md={{ span: 8 }}>
                    { this.isEmpty(user) == false &&
                        <Card>
                            <Row>
                                <Col md={{ span: 18, offset: 6 }}>
                                    {/* <img src={userProfile} style={{ height: '40%', width: '40%' }} alt="logo" /> */}
                                    <div className="image-cropper-dashboard">
                                        <Image
                                            src={(user && user.profile !== null) ? (user && user.profile.profilePhoto) : userProfileImageHolder}
                                            height={200}
                                            width={200}
                                            style={style.profileImage}
                                        />
                                    </div>
                                    <h1 style={{ fontWeight: "bold" }} className="GrayText">{user.first_name + ' ' + user.last_name}</h1>
                                    <h3 style={{ fontWeight: "normal" }} className="GrayText">{user.profile && user.profile.phoneNumber}</h3>
                                    {/* <h3 style={{ fontWeight: "normal" }} className="GrayText">Joined January 2019</h3> */}

                                </Col>
                            </Row>

                        </Card>
                    }
                    </Col>
                    <Col md={{ span: 16 }}>
                        <div style={{ paddingLeft: '24px' }}>
                            <h3 style={{ fontWeight: "normal", textAlign: 'center', paddingTop: '24px' }} className="GrayText">"{user.profile && user.profile.description}"</h3>

                            {/* <h3 style={{ fontWeight: "normal", textAlign: 'center', paddingTop: '20px', paddingBottom: '20px', textDecoration: 'underline' }} className="GrayText" onClick={this.showDescriptionModal}>Edit Description</h3> */}
                            <Tabs defaultActiveKey="1" onChange={this.callback} >
                                <TabPane tabBarStyle={{ color: "#4c4c4c4" }} tab="Posted Trips - Upcoming" key="1">
                                    {
                                        upcomingTrips.length > 0 ?
                                        upcomingTrips.map(trip => (
                                            <div>
                                            <Row>
                                        <Col md={{ span: 20 }}>
                                            <Card>
                                                <Row>
                                                    <Col md={{ span: 3 }}>
                                                        {/* <img src={userProfile} style={{ height: '80%', width: '80%' }} alt="logo" /> */}
                                                        <div className="image-cropper">
                                                            <Image
                                                                src={trip.user.profile !== null ? trip.user.profile.profilePhoto : userProfileImageHolder}
                                                                height={100}
                                                                width={100}
                                                                style={style.profileImage}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col md={{ span: 14 }}>
                                                        <h3 style={{ fontWeight: "bold", color: "#0099ff" }} >
                                                            <Link to={`/trip-detail/${trip.id}`}>
                                                                {trip.originCity} to {trip.destinationCity}
                                                            </Link>
                                                        </h3>
                                                        <h3 style={{ fontWeight: "normal", }} className="GrayText">{moment(trip.departureDate).format('dddd, D MMMM YYYY')} at {moment(trip.departureTime, "hh:mm").format("hh:mm A")}</h3>
                                                    </Col>
                                                    <Col md={{ span: 6 }}>
                                                        <h3 style={{ fontWeight: "bold", }} className="GrayText">
                                                        <NumberFormat value={trip.pricePerSeat} displayType={'text'} thousandSeparator={true} prefix={'Ush '} style={{ color: "#05ac09", fontWeight: "bold" }} />
                                                             &nbsp; per seat</h3>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>
                                    </Row>
                                    <br/>                                              
                                    </div>
                                        ))
                                        :
                                        <div>
                                            <Row>
                                                <Col md={{ span: 20}}>
                                                    <h4>{user.last_name} has no upcoming trips.</h4>
                                                </Col>
                                            </Row>
                                        </div>
                                    }

                                </TabPane>
                            </Tabs>
                        </div>
                    </Col>
                </Row>

            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.token !== null,
        loggedInUser: state.currentUser,
        token: state.token
    }
}

export default connect(mapStateToProps, null)(UserProfile);
// export default UserProfile;
